import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { useFlocknoteAppState } from "Flocknote/state";

import DuplicateFinderDashboardWidget from "AccountMerge/DuplicateFinderDashboardWidget";

import Portal from "Utilities/PortalMaker";
import { useDashboardPortalElement } from "Utilities/PortalMaker/useDashboardPortalElement";

import AdventFlyers from "./DashboardRightSections/AdventFlyers";
import AnimateEntrance from "./DashboardRightSections/AnimateEntrance";
import BrisbaneReport from "./DashboardRightSections/BrisbaneReport";
import LentTTJFlyers from "./DashboardRightSections/LentTTJFlyers";
import Library from "./DashboardRightSections/Library";
import NewFeatures from "./DashboardRightSections/NewFeatures";
import OurMission from "./DashboardRightSections/OurMission";
import SideLinks from "./DashboardRightSections/SideLinks";

RightDashboardPortal.propTypes = {
  settings: PropTypes.object,
};

export default function RightDashboardPortal({ settings }) {
  const [state] = useFlocknoteAppState();
  const [childCount, setChildCount] = useState(0);
  const dashboardRightPortal = useDashboardPortalElement({
    selector: "#dashboard_right_content",
    childCount,
    setChildCount,
    dashboardTick: state.dashboardTick,
  });
  const delayOffset = 0.15;

  useEffect(() => {
    if (dashboardRightPortal?.childElementCount) {
      setChildCount(dashboardRightPortal.childElementCount);
    }
  }, [dashboardRightPortal]);

  return (
    <>
      {dashboardRightPortal ? (
        <Portal to={dashboardRightPortal}>
          <AnimateEntrance delay={settings.delayOffset * 0.5}>
            <BrisbaneReport
              showBrisbaneDownload={settings?.showBrisbaneDownload}
            />
          </AnimateEntrance>

          <AnimateEntrance delay={settings.delayOffset * 1}>
            <Library
              hasWOF={settings.integrations?.includes("wof")}
              canCompose={settings.canComposeOnAtLeastOneGroup}
              networkID={settings.networkID}
            />
          </AnimateEntrance>

          <AnimateEntrance delay={delayOffset * 2}>
            <AdventFlyers settings={settings} />
          </AnimateEntrance>

          <AnimateEntrance delay={delayOffset * 2}>
            <LentTTJFlyers settings={settings} />
          </AnimateEntrance>

          <AnimateEntrance delay={delayOffset * 3}>
            <NewFeatures
              show={settings.isSuperAdmin || settings.isGroupAdminForAnyGroup}
            />
          </AnimateEntrance>

          <AnimateEntrance delay={delayOffset * 4}>
            <OurMission
              show={settings.isSuperAdmin || settings.isGroupAdminForAnyGroup}
            />
          </AnimateEntrance>

          <AnimateEntrance delay={delayOffset * 5}>
            <DuplicateFinderDashboardWidget
              show={settings.isSuperAdmin || settings.isGroupAdminForAnyGroup}
            />
          </AnimateEntrance>

          <AnimateEntrance delay={delayOffset * 6}>
            <SideLinks />
          </AnimateEntrance>
        </Portal>
      ) : null}
    </>
  );
}